import React from 'react'

import { BasicModal } from '@/components/layout/modals/BasicModal'
import { Button } from '@/components/buttons/Button'
import UserForm from '../UserForm'

export const AddNewUserButton = ({
  playbooks,
  tagCategories,
  createNewUser,
  userOrganizationId,
  orgRealtimeCoachingAccess,
  orgDesktopEnterpriseEnabled,
  tags,
  qaEnabled,
  qaCopilotEnabled,
  agentGPTEnabled,
  toolsEnabled,
}) => {
  return (
    <BasicModal
      trigger={(handleOpen) => (
        <Button brand onClick={handleOpen} data-testid="add-new-user-button-default">
          Add New User
        </Button>
      )}
      title="Add New User"
      size="small"
    >
      {(handleClose) => (
        <UserForm
          playbooks={playbooks}
          tagCategories={tagCategories}
          handleSubmitUser={createNewUser}
          userOrganizationId={userOrganizationId}
          realtimeCoachingAccessEnabled={orgRealtimeCoachingAccess}
          orgDesktopEnterpriseEnabled={orgDesktopEnterpriseEnabled}
          tags={tags}
          qaEnabled={qaEnabled}
          qaCopilotEnabled={qaCopilotEnabled}
          agentGPTEnabled={agentGPTEnabled}
          toolsEnabled={toolsEnabled}
          modalClose={handleClose}
        />
      )}
    </BasicModal>
  )
}
